import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const PasswordVisibility = ({
  setShowPassword,
  showPassword,
  iconButtonProps,
}) => {
  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  return (
    <InputAdornment position="end">
      <IconButton
        onClick={handleShowPassword}
        onMouseDown={handleMouseDownPassword}
        aria-pressed={showPassword}
        {...iconButtonProps}
      >
        {showPassword ? <Visibility /> : <VisibilityOff />}
      </IconButton>
    </InputAdornment>
  );
};

export default PasswordVisibility;
